export const HOME = '/';
export const IOC = '/ioc';
export const LOGIN = '/login';
export const IMPERSONATE = '/customers/impersonate';
export const INDICATORS = '/indicators';
export const SOURCES = '/sources/:state';
export const SOURCE_MANAGEMENT = '/source-management';
export const FEED = '/feed';
export const FEEDS = '/feeds';
export const FEEDS_GLOBAL = '/feeds/global';
export const FEEDS_ORGANISATION = '/feeds/organisation';
export const FEEDS_MY = '/feeds/my';
export const COLLECTIONS = '/collections';
export const FEED_SA = '/feed-settings';
export const FILTER_PROFILES = '/filter-profiles';
export const PROFILE = '/profile';
export const ACCOUNT = '/account';
export const ORGANIZATION = '/organization';
export const SUBSCRIPTION = '/subscription';
export const RESET_PASSWORD = '/reset';
export const CONFIRM_RESET_PASSWORD = '/reset/confirm/:uid/:token';
export const CONFIRM_EXTEND_SUBSCRIPTION =
  '/extend-subscription/confirm/:uid/:token';
export const EXPLORE = '/explore';
export const EXPLORE_REVERSE_A_QUERY = '/explore/reverse-a';
export const EXPLORE_REVERSE_A_QUERY_SPECIFIC = '/explore/reverse-a/:recipeid';
export const EXPLORE_FORWARD_A_QUERY = '/explore/forward-a';
export const EXPLORE_FORWARD_A_QUERY_SPECIFIC = '/explore/forward-a/:recipeid';
export const EXPLORE_HOSTING_INFRASTRUCTURE_ASNS =
  '/explore/hosting-infra-asns';
export const EXPLORE_HOSTING_INFRASTRUCTURE_ASNS_SPECIFIC =
  '/explore/hosting-infra-asns/:recipeid';
export const EXPLORE_HOSTING_INFRASTRUCTURE_IPS = '/explore/hosting-infra-ips';
export const EXPLORE_HOSTING_INFRASTRUCTURE_IPS_SPECIFIC =
  '/explore/hosting-infra-ips/:recipeid';
export const EXPLORE_SUBDOMAIN_FINDER = '/explore/subdomain-finder';
export const EXPLORE_SUBDOMAIN_FINDER_SPECIFIC =
  '/explore/subdomain-finder/:recipeid';
export const LATEST_DNS_RECORDS = '/explore/latest-dns-records';
export const LATEST_DNS_RECORDS_SPECIFIC =
  '/explore/latest-dns-records/:recipeid';
export const EXPLORE_SHADOW_IT = '/explore/shadow-it';
export const EXPLORE_SHADOW_IT_SPECIFIC = '/explore/shadow-it/:recipeid';
export const NAME_IN_TXT = '/explore/name-in-txt';
export const NAME_IN_TXT_SPECIFIC = '/explore/name-in-txt/:recipeid';
export const EXPLORE_DOMAINS_SERVER = '/explore/domain-on-server';
export const EXPLORE_DOMAINS_SERVER_SPECIFIC =
  '/explore/domain-on-server/:recipeid';
export const EXPLORE_DANGLING_DNS_PROTECTION = '/explore/dangling-dns-record';
export const EXPLORE_DANGLING_DNS_PROTECTON_SPECIFIC =
  '/explore/dangling-dns-record/:recipeid';
export const EXPLORE_DANGLING_DNS_RECOURDS_COUNT =
  '/explore/dangling-dns-records-count';
export const EXPLORE_DANGLING_DNS_RECOURDS_COUNT_SPECIFIC =
  '/explore/dangling-dns-records-count/:recipeid';
export const EXPLORE_TYPOSQUATTING = '/explore/typosquatting/:recipeid';
export const EXPLORE_TYPOSQUATTING_SPECIFIC = '/explore/typosquatting/';
export const EXPLORE_SPOOFING = '/explore/brand-impersonation/:recipeid';
export const EXPLORE_SPOOFING_SPECIFIC = '/explore/brand-impersonation/';
export const EXPLORE_NAME_SERVER_CHANGES = '/explore/ns-changes';
export const EXPLORE_NAME_SERVER_CHANGES_SPECIFIC =
  '/explore/ns-changes/:recipeid';
export const EXPLORE_TXT = '/explore/domain-txt-records';
export const EXPLORE_TXT_SPECIFIC = '/explore/domain-txt-records/:recipeid';
export const EXPLORE_QUERY_BUILDER = '/explore/query-builder';
export const EXPLORE_QUERY_BUILDER_SPECIFIC =
  '/explore/query-builder/:recipeid';
export const EXPLORE_IP_DIVERSITY = '/explore/ip-diversity/';
export const EXPLORE_IP_DIVERSITY_SPECIFIC = '/explore/ip-diversity/:recipeid';
export const EXPLORE_RESULT = '/explore-result';
export const ENRICHMENT = '/enrichment';
export const ENRICHMENT_LANDING = '/enrichment-landing';
export const BULK_DATA_FEEDS = '/bulk-data-feeds';
export const DATA_MARKETPLACE_FEED = '/data-marketplace-feed/:categorySlug';
export const DASHBOARD = '/dashboard/:id';
export const PLAYBOOKS = '/scheduler';
export const CUSTOMERS = '/customers';
export const CUSTOMER_USERS = '/customer/:uuid/:id/users/';
export const VALIDATION = '/validation';
export const PERFORMANCE = '/performance';
export const FEED_REPORTS = '/feeds_report';
export const MONITORING = '/monitoring';
export const QUERY_HISTORY = '/query-history';
export const WEB_SCANNER = '/web-scanner';
export const DOWNLOAD_CONTENT = '/download/:fileUUID';
export const API_RESPONSE = '/data';
export const REGISTER = '/register';
export const BLOG = '/blog';
